<script lang="ts">
	import { devices_settings } from 'src/stores/device-runtime/status';
	import { readDeviceSettings } from 'src/stores/device-runtime/status-selectors';
	//Services
	import { postReq } from '../../../../services/http';
	import { gen2CloudReq, gen2Request } from '../../../../services/gen_2_http_reqs';
	import { format } from '../../../../services/i18n';
	//Helpers
	import {
		get_gen_2_component_channel_structure,
		get_gen_2_component_from_category,
		real_id,
	} from '../../../../helpers/interface_helpers';
	//Stores
	import { devices } from 'src/stores/lists/devices';
	//Types
	import type { SettingRequest } from '../../../../types/requests/settings/setting';
	//Design system components
	import { Button, Input, toast } from '@Shelly/shelly-design-system';
	import SyncName from '../../ApplicationSettings/SyncName.svelte';
	import { onSettingsResponse } from 'src/helpers/device_settings_helpers';
	import { getTrvComponentByDevice } from 'src/helpers/virtual_helpers/blutrv_helpers';

	export let device;

	const id = real_id(device.id);

	let settings = readDeviceSettings(id);

	let name = settings?.[`${get_gen_2_component_channel_structure(device)}`]?.name
		? settings[`${get_gen_2_component_channel_structure(device)}`].name
		: device.name;
	$: error = name === '' && device.name_sync;
	let cache = name;

	$: synced = device.name_sync;
	let loading = false;

	const method = `${get_gen_2_component_from_category(device)}.SetConfig`;

	const saveName = async () => {
		name = name.trim();
		if (cache !== name && name !== '') {
			const params = { id: device.channel, config: { name: name } };
			loading = true;
			if (synced) {
				let res: SettingRequest;
				if (device.type === 'SBTR-001AEU') {
					const BluTRVid = getTrvComponentByDevice(device)?.id;
					if (!BluTRVid) return { isok: false } as SettingRequest;
					res = await gen2CloudReq(
						id,
						device.type,
						'blutrv.setconfig',
						{
							id: BluTRVid,
							config: { name },
						},
						true,
					);
					if (res?.errors) {
						if (res?.isok) {
							toast.open({
								type: 'success',
								title: $format('command_is_sent_to_the_device', {
									default: 'The command is sent to the device.',
								}),
							});
						} else {
							onSettingsResponse(res, device);
						}
					}
				} else {
					res = await gen2Request(device, method, params);
				}

				if (!res.isok) {
					toast.open({
						type: 'danger',
						title: $format('error_global'),
					});
				}
			}
			// if (res.isok) {
			// if (synced) {
			device.name = name;
			cache = name;
			devices.update(device);

			const int_res = await postReq('interface/device/save', {
				id: device.id, //this must be that type of id, because real id messes interface data and overrides channels so they became as one
				data: JSON.stringify(device),
			});
			if (int_res.isok) {
				if (device.type === 'SBTR-001AEU') {
					settings[`blutrv:${device.id.split('_2')[1]}`].name = name;
				} else {
					settings[`${get_gen_2_component_channel_structure(device)}`].name = name;
				}
				devices_settings.update_devices_settings(id, settings);

				toast.open({
					type: 'success',
					title:
						$format('device_name_scc_toast', { values: { value: name } }) ||
						`Device name changed to ${name}`,
				});
			} else {
				toast.open({ type: 'danger', title: $format('error_global') });
			}
			// }

			// cache = name;
			// } else {
			// name = cache;
			// toast.open({
			// 	type: 'danger',
			// 	title: $format('device_name_err_toast') || `Cloud not change device name.`
			// });
			// }
			loading = false;
		}
	};
</script>

<Input
	class="mb-s"
	icon="fas fa-microchip"
	size="m"
	label={$format('sub_settings_title_device_name')}
	error={error ? $format('input_error_empty_name', { default: 'Name cannot be empty' }) : ''}
	bind:value={name}
	on:enter={saveName}
	id="input-51wkv69"
	aria-labelledby="input-51wkv69"
/>
<SyncName
	nameType="device"
	{device}
	info={$format('channel_rename_description', {
		default:
			'Keep the channel name in sync with the name given in the application. The sync is only from the application to the device and not vice-versa.',
	})}
/>
<Button
	{loading}
	size="m"
	class="mt-s"
	width="full"
	on:click={saveName}
	disabled={error || cache === name}
>
	{$format('button_save')}
</Button>
